/* =========================================================
   DT — English Cares (v3.0.8 STABLE + FLOAT RESTORE)
   ✅ Bubble updates without refresh
   ✅ Drawer opens once
   ✅ Drawer refreshes quickly + re-sync once committed
   ✅ Restores Back-to-Top + Social Dock toggle (safe)
   ✅ Guarded so it runs ONLY once (no double patch)
========================================================= */

(function () {
  // ✅ Run-once guard
  if (window.__DT_EC_JS_LOADED__) return;
  window.__DT_EC_JS_LOADED__ = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getHeaderRoot() {
    return document.querySelector("[data-dt-custom-header]") || document;
  }

  /* ---------------------------
     CART BUBBLE (custom header)
  --------------------------- */
  function setCartCount(count) {
    var root = getHeaderRoot();

    $all(".cart-bubble__text-count, [data-cart-count]", root).forEach(function (n) {
      n.textContent = String(count);
      n.classList.toggle("hidden", count <= 0);
    });

    $all(".cart-bubble", root).forEach(function (bubble) {
      bubble.classList.toggle("visually-hidden", count <= 0);
    });
  }

  function fetchCartNoStore() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Accept": "application/json" }
    }).then(function (r) { return r.json(); });
  }

  function waitForCartCommit(prevCount, opts) {
    opts = opts || {};
    var attempts = typeof opts.attempts === "number" ? opts.attempts : 6;
    var waitMs = typeof opts.waitMs === "number" ? opts.waitMs : 55;

    function loop(i) {
      return fetchCartNoStore()
        .then(function (cart) {
          var count = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
          setCartCount(count);

          if (typeof prevCount !== "number" || count !== prevCount) return cart;

          if (i < attempts - 1) {
            return new Promise(function (res) { setTimeout(res, waitMs); })
              .then(function () { return loop(i + 1); });
          }
          return cart;
        })
        .catch(function () { return null; });
    }

    return loop(0);
  }

  /* ---------------------------
     THEME DRAWER HELPERS
  --------------------------- */
  function getThemeDrawerEl() {
    return document.querySelector("cart-drawer-component.cart-drawer") ||
           document.querySelector("cart-drawer-component");
  }

  function isDrawerOpen(drawerEl) {
    try { return !!(drawerEl && drawerEl.querySelector("dialog[open]")); }
    catch (e) { return false; }
  }

  var EC_OPEN_LOCK = false;
  function safeOpenDrawerOnce() {
    var drawer = getThemeDrawerEl();
    if (!drawer) return false;

    if (isDrawerOpen(drawer)) return true;

    if (EC_OPEN_LOCK) return true;
    EC_OPEN_LOCK = true;
    setTimeout(function(){ EC_OPEN_LOCK = false; }, 380);

    if (typeof drawer.open === "function") {
      drawer.open();
      return true;
    }

    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      try { trigger.click(); return true; } catch (e) {}
    }

    window.location.href = "/cart";
    return false;
  }

  /* ---------------------------
     REFRESH DRAWER IN-PLACE
  --------------------------- */
  function refreshDrawerInPlaceFromSections() {
    var drawer = getThemeDrawerEl();
    if (!drawer) return Promise.resolve(false);

    var liveCartItems = drawer.querySelector("cart-items-component[data-section-id]") ||
                        document.querySelector("cart-items-component[data-section-id]");
    if (!liveCartItems) return Promise.resolve(false);

    var sectionId = liveCartItems.getAttribute("data-section-id");
    if (!sectionId) return Promise.resolve(false);

    var url = "/?sections=" + encodeURIComponent(sectionId);

    var liveDialog = drawer.querySelector("dialog");
    if (liveDialog) liveDialog.classList.add("dt-ec-cart-loading");

    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        if (!html) return false;

        var tmp = document.createElement("div");
        tmp.innerHTML = html;

        var freshDrawer = tmp.querySelector("cart-drawer-component.cart-drawer") ||
                          tmp.querySelector("cart-drawer-component");
        if (!freshDrawer) return false;

        var freshDialog = freshDrawer.querySelector("dialog");
        var freshCartItems = freshDrawer.querySelector("cart-items-component");
        if (!freshDialog || !freshCartItems) return false;

        var liveDrawer = getThemeDrawerEl();
        if (!liveDrawer) return false;

        var liveDialog2 = liveDrawer.querySelector("dialog");
        var liveCartItems2 = liveDrawer.querySelector("cart-items-component");
        if (!liveDialog2 || !liveCartItems2) return false;

        liveDialog2.className = freshDialog.className;
        liveDialog2.setAttribute("aria-labelledby", freshDialog.getAttribute("aria-labelledby") || "");
        var sticky = freshDialog.getAttribute("cart-summary-sticky");
        if (sticky != null) liveDialog2.setAttribute("cart-summary-sticky", sticky);

        liveCartItems2.innerHTML = freshCartItems.innerHTML;

        return true;
      })
      .catch(function () { return false; })
      .finally(function () {
        var d = getThemeDrawerEl();
        var dlg = d && d.querySelector("dialog");
        if (dlg) dlg.classList.remove("dt-ec-cart-loading");
      });
  }

  /* ---------------------------
     MUTATION GUARDS
  --------------------------- */
  var EC_MUT_LOCK = false;
  var EC_LAST_MUT = 0;

  function shouldRunMutation() {
    var now = Date.now();
    if (now - EC_LAST_MUT < 260) return false;
    EC_LAST_MUT = now;
    return true;
  }

  function afterCartMutation(opts) {
    opts = opts || {};
    if (!shouldRunMutation()) return Promise.resolve();
    if (EC_MUT_LOCK) return Promise.resolve();
    EC_MUT_LOCK = true;

    return fetchCartNoStore()
      .then(function (prevCart) {
        var prevCount = prevCart && typeof prevCart.item_count === "number" ? prevCart.item_count : undefined;

        if (opts.openDrawer) safeOpenDrawerOnce();

        var firstRefresh = refreshDrawerInPlaceFromSections();

        var secondRefresh = waitForCartCommit(prevCount, { attempts: 6, waitMs: 55 })
          .then(function () { return refreshDrawerInPlaceFromSections(); });

        return Promise.allSettled([firstRefresh, secondRefresh]).then(function () {});
      })
      .finally(function () {
        setTimeout(function () { EC_MUT_LOCK = false; }, 120);
      });
  }

  /* ---------------------------
     BACK TO TOP + SOCIAL DOCK
  --------------------------- */
  function initFloatingUI() {
    // Back to top
    var backBtn = document.querySelector(".ec-back-to-top");
    if (backBtn) {
      var onScroll = function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        backBtn.classList.toggle("is-visible", y > 350);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();

      backBtn.addEventListener("click", function () {
        try {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (e) {
          window.scrollTo(0, 0);
        }
      });
    }

    // Social dock toggle
    var dock = document.querySelector(".ec-social-dock");
    if (dock) {
      // default collapsed if you want (keep as-is if your HTML sets it)
      var toggle = dock.querySelector(".ec-social-toggle");
      if (toggle) {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          dock.classList.toggle("is-collapsed");
        });
      }

      // press effect
      $all(".ec-social-btn", dock).forEach(function (a) {
        a.addEventListener("click", function () {
          a.classList.add("is-press");
          setTimeout(function(){ a.classList.remove("is-press"); }, 240);
        });
      });
    }
  }

  /* ---------------------------
     MAIN
  --------------------------- */
  ready(function () {
    // ✅ Restore floating UI
    initFloatingUI();

    // Custom header cart open
    var headerRoot = getHeaderRoot();
    var customCartBtn = $('[data-dt-cart-open]', headerRoot);
    if (customCartBtn) {
      customCartBtn.addEventListener("click", function (e) {
        e.preventDefault();
        safeOpenDrawerOnce();
        refreshDrawerInPlaceFromSections();
      }, true);
    }

    // Initial bubble sync
    fetchCartNoStore().then(function (cart) {
      var count = cart && typeof cart.item_count === "number" ? cart.item_count : 0;
      setCartCount(count);
    }).catch(function(){});

    // ✅ Patch fetch ONCE only
    if (window.fetch && !window.__DT_EC_FETCH_PATCHED__) {
      window.__DT_EC_FETCH_PATCHED__ = true;

      var _fetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        return _fetch.apply(this, args).then(function (res) {
          try {
            var url = args[0];
            url = String(url && url.url ? url.url : url);

            var isAdd = (url.indexOf("/cart/add") > -1) || (url.indexOf("/cart/add.js") > -1);
            var isMut =
              isAdd ||
              url.indexOf("/cart/change") > -1 ||
              url.indexOf("/cart/change.js") > -1 ||
              url.indexOf("/cart/update") > -1 ||
              url.indexOf("/cart/update.js") > -1 ||
              url.indexOf("/cart/clear") > -1 ||
              url.indexOf("/cart/clear.js") > -1;

            if (isMut && res && res.ok) {
              setTimeout(function () {
                afterCartMutation({ openDrawer: isAdd });
              }, 0);
            }
          } catch (e) {}
          return res;
        });
      };
    }

    // Form submit fallback
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!f) return;

      var action = (f.getAttribute("action") || "").toLowerCase();
      var hasVariant = !!f.querySelector('[name="id"]');
      if (action.indexOf("/cart/add") === -1 && !hasVariant) return;

      setTimeout(function () {
        afterCartMutation({ openDrawer: true });
      }, 0);
    }, true);

    // Debug helpers
    window.EC_refreshCartUI = afterCartMutation;
    window.EC_openDrawer = safeOpenDrawerOnce;
    window.EC_refreshDrawer = refreshDrawerInPlaceFromSections;
  });

  // tiny loading CSS (safe)
  var style = document.createElement("style");
  style.textContent = `
    cart-drawer-component dialog.dt-ec-cart-loading { cursor: progress; }
    cart-drawer-component dialog.dt-ec-cart-loading .cart-drawer__items,
    cart-drawer-component dialog.dt-ec-cart-loading .cart-items__wrapper {
      opacity: .72; transition: opacity .10s ease;
    }
  `;
  document.head.appendChild(style);
})();

